import { Component, AfterViewInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../security/services/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as Prism from 'prismjs';
import { Empresa } from '@core/models';
import { CoreFacade } from '@core/core.facade';
import { FormControl } from '@angular/forms';
import { of } from 'rxjs';
import { environment } from '@env/environment';
@Component({
	selector: 'app-header-inner',
	templateUrl: './header-inner.component.html',
})
export class HeaderInnerComponent implements AfterViewInit {
	public userPermisos: any;
	permisos: string[];
	private buscarEmpresa = new FormControl();

	constructor(
		private _apiService: ApiService,
		private http: HttpClient,
		public authService: AuthService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private coreFacade: CoreFacade
	) {}

	logout() {
		this.authService.logout();
	}

	goToLogin() {
		this.authService.login();
	}

	goToEmpresa(empresa: Empresa) {
		this.coreFacade.setEmpresa = empresa;
		this.coreFacade.setEmpresaId = empresa.id;
		this._router.navigate(['/empresas', empresa.id]);
	}

	faq() {
		this._router.navigate(['faq-list']);
	}

	get rolesFiltrados$() {
		return of(this.authService.getUser().roles.filter(rol => rol.nroAplicacion === environment.nroAplicacion));
	}

	/**
	 * @method ngAfterViewInit
	 */
	ngAfterViewInit() {
		Prism.highlightAll();
	}
}
